import { render } from "./HomeDetail.vue?vue&type=template&id=63406e5e&scoped=true"
import script from "./HomeDetail.vue?vue&type=script&lang=js"
export * from "./HomeDetail.vue?vue&type=script&lang=js"

import "./HomeDetail.vue?vue&type=style&index=0&id=63406e5e&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63406e5e"]])

export default __exports__